import { Box, Typography, Grid, Card } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';

const DAYS_OF_WEEK = [
  'Domingo',
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado'
];

function formatTime(time: string) {
  if (!time) return '';
  return time.substring(0, 5);
}

function isOpenDay(schedule: { start_time: string; end_time: string; }) {
  return !(schedule.start_time === '00:00:00' && schedule.end_time === '00:00:00');
}

interface Schedule {
  id: string;
  day_of_week: number;
  start_time: string;
  end_time: string;
  interval_minutes: number;
  is_active: boolean;
}

interface RoomSchedulesProps {
  schedules: Schedule[];
}

export function RoomSchedules({ schedules }: RoomSchedulesProps) {
  const allSchedules = (schedules || [])
    .filter((schedule: Schedule) => schedule.is_active)
    .sort((a: Schedule, b: Schedule) => a.day_of_week - b.day_of_week);

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <ScheduleIcon sx={{ color: '#3B4EFF', fontSize: 22 }} />
        <Typography fontWeight={700} fontSize={17} color="#23272E">Horários de Funcionamento</Typography>
      </Box>
      <Grid container spacing={2}>
        {allSchedules.map((schedule: Schedule) => {
          const isOpen = isOpenDay(schedule);
          return (
            <Grid item xs={12} sm={6} md={4} key={schedule.id}>
              <Card
                sx={{
                  border: `1.5px solid ${isOpen ? '#A7F3D0' : '#E5E7EB'}`,
                  background: isOpen ? 'linear-gradient(135deg, #F6FFF9 60%, #E6F9ED 100%)' : '#F3F4F6',
                  borderRadius: 2,
                  p: 2,
                  minHeight: 110,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  boxShadow: isOpen ? '0 2px 8px 0 rgba(34,197,94,0.06)' : 'none',
                  transition: 'box-shadow 0.2s, border 0.2s, background 0.2s',
                  '&:hover': isOpen
                    ? {
                      boxShadow: '0 4px 16px 0 rgba(34,197,94,0.10)',
                      borderColor: '#6EE7B7',
                    }
                    : {},
                  cursor: isOpen ? 'pointer' : 'default',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography fontWeight={600} color="#23272E" fontSize={15}>
                    {DAYS_OF_WEEK[schedule.day_of_week]}
                  </Typography>
                  <Box
                    sx={{
                      fontWeight: 600,
                      fontSize: 12,
                      px: 1,
                      py: 0.2,
                      borderRadius: 1,
                      border: isOpen ? '1px solid #22C55E' : '1px solid #E5E7EB',
                      color: isOpen ? '#22C55E' : '#6B7280',
                      background: isOpen ? 'rgba(34,197,94,0.07)' : 'transparent',
                      minWidth: 44,
                      textAlign: 'center',
                    }}
                  >
                    {isOpen ? 'Aberto' : 'Fechado'}
                  </Box>
                </Box>
                {isOpen ? (
                  <>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#23272E' }}>
                      <ScheduleIcon sx={{ fontSize: 16, color: '#22C55E' }} />
                      <Typography fontSize={14}>
                        {formatTime(schedule.start_time)} às {formatTime(schedule.end_time)}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#6B7280' }}>
                      <span style={{ fontSize: 15 }}>⏱️</span>
                      <Typography fontSize={12}>
                        Intervalo de {schedule.interval_minutes} minutos
                      </Typography>
                    </Box>
                  </>
                ) : (
                  <Typography fontSize={13} color="#EF4444" fontWeight={500} sx={{ fontStyle: 'italic' }}>
                    Área fechada neste dia
                  </Typography>
                )}
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
} 